import moment from 'moment'

export default {
    methods: {
        async searchsData(tipo) {
            this.resetDataGet()
            const await00 = this.onInit()
            if (tipo === 'centro') {
                this.nameSearchs = 'AportesCentros'
                await this.getDataGet({ route: 'get_centroaporte', data: { id_datos_contacto: this.searchSw.value, mes_periodo: this.mesPeriodo.id, ano_periodo: this.anoPeriodo.id } })
                this.updateDataForm({ state: 'servicios_activos', data: [] })
            }
            if (tipo === 'razon') {
                this.nameSearchs = 'AportesRazon'
                await this.getDataGet({ route: 'get_razonaporte', data: { id_datos_razon: this.searchSw.value, mes_periodo: this.mesPeriodo.id, ano_periodo: this.anoPeriodo.id } })
                this.updateDataForm({ state: 'servicios_activos', data: [] })
            }
            if (tipo === 'asesor') {
                this.nameSearchs = 'AportesAsesor'
                await this.getDataGet({ route: 'get_asesoraporte', data: { id_datos_asesor: this.searchSw.value, mes_periodo: this.mesPeriodo.id, ano_periodo: this.anoPeriodo.id } })
                this.updateDataForm({ state: 'servicios_activos', data: [] })
            }

        },
        limpiarSearchs() {
            this.searchSw.value = ''
            this.resetDataGet()
            this.mesPeriodo = { id: this.fecha().fecha.mesHoy, name: this.gettersDatalist('list_mes', this.fecha().fecha.mesHoy)[0].name }
            this.anoPeriodo = { id: this.fecha().fecha.anoHoy, name: this.gettersDatalist('list_ano', this.fecha().fecha.anoHoy)[0].name }
        },
    },
}